import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';
import { ONE_DAY } from './time-frames';

export const InPastDayMatcher: FieldMatcher = {
  name: 'inPastDay',
  displayName: 'Within last day',
  options: {
    setValue: (): string => Date.now().toString(),
    chipFormatter: (value: string): string =>
      `since ${new Intl.DateTimeFormat('en-US', { timeStyle: 'short' }).format(
        new Date(Number(value) - ONE_DAY)
      )} yesterday`,
  },
};